/**
 * Supported HTML event handler props for custom-logic-driven local UI state.
 * Kept Zod-free so published renderers can import the allow-list without the custom-logic schemas.
 */
export const CUSTOM_LOGIC_EVENT_HANDLER_PROPS = [
  "onClick",
  "onMouseEnter",
  "onMouseLeave",
  "onFocus",
  "onBlur",
  "onKeyDown",
  "onKeyUp",
  "onKeyPress",
] as const;

export type CustomLogicEventHandlerProp = (typeof CUSTOM_LOGIC_EVENT_HANDLER_PROPS)[number];
